// J-376: whether a component is drawn inside the signed-in shell, whose own `<main>` holds the outlet.
import { createContext } from "react";

export const InShellContext = createContext(false);
